<template>
  <div class="box">

    <!-- 地图容器 -->
    <div id="container"></div>



    <!-- 多选框 -->
    <el-checkbox-group v-model="checkList" class="checkboxGroup">


      <!-- 全城市管理需要显示 -->
      <el-select v-model="city_list_name" placeholder="请选择城市" style="width: 150px;" @change="cityChange" clearable
        @clear="cityClear" v-show="showList">
        <el-option v-for="item in city_list" :key="item.city.city_code" :label="item.city.name" :value="item">
        </el-option>
      </el-select>



      <div class="div-color" style="font-size: 14px;cursor: pointer;font-weight:800;margin: 0 0 0 20px;"
        v-for="(item, index) in priceListAll">

        {{item.alias}} -
        {{item.num}}

      </div>

      <!-- <el-checkbox v-for="(item, index) in checbBoxText" :label="item.status" checked
        @change="checkboxChenge($event,item.status) ">
        <div style="padding-left: 10px;">
          {{item.alias}} -
          {{priceList[item.status]}}
        </div>

      </el-checkbox> -->
      <div style="font-size: 14px;cursor: pointer;font-weight:600;margin: 0 0 10px 20px;">
        当前在线<span style="margin: 0 5px;color: red;">{{all}}</span>人
      </div>

      <i class='el-icon-refresh' style="font-size: 20px;cursor: pointer;font-weight: 800;margin-left: 20px;"
        @click="searchPeople"></i>
    </el-checkbox-group>





  </div>
</template>

<script>
  var trafficLayer;
  var ruler1;
  var infoWindow;
  var _this, text, circle, marker, polyline1, polyline2, polyline3,
    leagueMarker,map;



  import axios from 'axios'; // AJAX封装类
  import {
    config
  } from '../../../utils/config'; //配置
  import bus from '../../common/bus';
  import tipModel from './tips.vue';
  export default {
    components: {
      tipModel
    },

    created() {

      _this = this;

      bus.$on('firstlog', msg => {

        _this.firstlog = msg

      });


      _this.$nextTick(function () {

        _this.onSocket();

      })








      // 获取司机状态
      _this.$post(
        "/driver/statusConf"
      ).then(res => {

        _this.checbBoxText = res.data;
        console.log(_this.checbBoxText)

      }).catch((err) => {

      })




      setTimeout(() => {


        // 地图初始化
        map = new AMap.Map('container', {
          //是否监控地图容器尺寸变化
          resizeEnable: true,
          //初始化地图层级
          zoom: 11,
          // 主题设置
          mapStyle: '',

        });

        var limit_num = 10;
        if(localStorage.getItem('city_tag')=='KUNMING'){
          limit_num = 500
        }

        // 联盟商家坐标
        _this.$post(
          "/admin.php/Business/ipcShoppingLists", {
            page: 1,
            limit: limit_num,
            shop_name: '',
            city_code: ''
          }).then(res => {

          if (res.data.length > 0) {

            for (let i = 0; i < res.data.length; i++) {

              leagueMarker = new AMap.Marker({
                icon: new AMap.Icon({
                  image: require('@/assets/League.png'),
                  size: new AMap.Size(25, 34), //图标大小
                  imageSize: new AMap.Size(25, 34)
                }),
                position: [res.data[i].lng, res.data[i].lat],
                size: new AMap.Size(25, 34),
                offset: new AMap.Pixel(-13, -30)
              });
              leagueMarker.setMap(map);

            }

          }

        }).catch((err) => {

        })


        // 使用地图工具(平移工具，测距工具)
        AMap.plugin(['AMap.RangingTool', 'AMap.CitySearch', 'AMap.Geocoder', 'AMap.Driving'], function () {

          map.addControl(new AMap.CitySearch())

        })
        // 将地图绑定点击事件   点击关闭信息窗口
        map.on('click', this.closePop);



        // 路况图层
        trafficLayer = new AMap.TileLayer.Traffic({
          zIndex: 10
        });
        // 测距功能
        ruler1 = new AMap.RangingTool(map);
        // 将路况图层加入到地图
        trafficLayer.setMap(map);
        // 隐藏路况图层
        trafficLayer.hide();
        // 弹出提示
        map.on("complete", function () {

          log.success("地图加载完成！");

        });




      }, 1);



    },

    beforeUpdate() {

      // _this.onSocket();

    },


    mounted() {


      this.city_code = ''

      this.searchPeople();




        // 请求城市列表接口   获取围栏信息
        _this.$post(
            "/admin.php/city/getCityDetails",
          )
          .then(res => {

            if (res.data.free_area_coordinate_array != null && res.data.free_area_coordinate_array != '[]') {

              var path1 = JSON.parse(res.data.free_area_coordinate_array);

              path1.push(JSON.parse(res.data.free_area_coordinate_array)[0]);

            }





            if (res.data.far_area_coordinate_array != null && res.data.far_area_coordinate_array != '[]') {

              var path2 = JSON.parse(res.data.far_area_coordinate_array);

              path2.push(JSON.parse(res.data.far_area_coordinate_array)[0]);

            }




            if (res.data.effective_area_coordinate_array != null && res.data.effective_area_coordinate_array != '[]') {

              var path3 = JSON.parse(res.data.effective_area_coordinate_array);

              path3.push(JSON.parse(res.data.effective_area_coordinate_array)[0]);

            }


            // 创建小围栏(绿色)
            polyline1 = new AMap.Polyline({
              path: path1,
              isOutline: true,
              outlineColor: 'transparent',
              borderWeight: 3,
              strokeColor: "green",
              strokeOpacity: 0.5,
              strokeWeight: 6,
              // 折线样式还支持 'dashed'
              strokeStyle: "solid",
              // strokeStyle是dashed时有效
              strokeDasharray: [10, 5],
              lineJoin: 'round',
              lineCap: 'round',
              zIndex: 50,
            })

            if (path2) {

              // 创建大围栏(粉色)
              polyline2 = new AMap.Polyline({
                path: path2,
                isOutline: true,
                outlineColor: 'transparent',
                borderWeight: 3,
                strokeColor: "#FF33FF",
                strokeOpacity: 0.5,
                strokeWeight: 6,
                // 折线样式还支持 'dashed'
                strokeStyle: "solid",
                // strokeStyle是dashed时有效
                strokeDasharray: [10, 5],
                lineJoin: 'round',
                lineCap: 'round',
                zIndex: 50,
              })

              polyline2.setMap(map);


            }



            if (path3) {
              // 创建大围栏(黑色)
              polyline3 = new AMap.Polyline({
                path: path3,
                isOutline: true,
                outlineColor: 'transparent',
                borderWeight: 3,
                strokeColor: "black",
                strokeOpacity: 0.5,
                strokeWeight: 6,
                // 折线样式还支持 'dashed'
                strokeStyle: "solid",
                // strokeStyle是dashed时有效
                strokeDasharray: [10, 5],
                lineJoin: 'round',
                lineCap: 'round',
                zIndex: 50,
              })
              polyline3.setMap(map);
            }


            polyline1.setMap(map);





            var x = res.data.name.indexOf('/');

            for (var i = 0; i < 1; i++) {
              x = res.data.name.indexOf('/', x + 1);
            }

            // console.log(x);

            // 如果为市级
            if (x < 0) {

              // 截取城市名称 如:XXXX / 截取字段
              var city_name = res.data.name.slice(res.data.name.indexOf('/') + 2)



            } else {

              // 截取城市名称 如:XXXX / 截取字段 / XXXX
              var city_name = res.data.name.slice(x + 2)

            }

            let areaCode;


            if(res.data.area_code.length== 4){
              areaCode = String(res.data.area_code)+'00'
            }else{
              areaCode = String(res.data.area_code)
            }


            // 将城市赋值
            _this.currentCity = city_name;

            console.log(res.data.name);
            console.log(city_name);

            //地图显示当前城市
            map.setCity(areaCode, function (params) {
              // 设置地图层级
              if (x < 0) {
                // 设置地图层级
                map.setZoom(11);
              } else {
                // 设置地图层级
                map.setZoom(14);
              }

            });




          }).catch((err) => {

          })



    },
    data() {
      return {

        firstlog: true,

        socket_relink_num: 0,

        sendData: {
          ws_mode: '',
          port: 'admin',
          platform: 'pc',
          token: '',
          hash_key: '',
          // city_tag: 'CHANGCHUN'
        },

        driver: [],

        driverMarks_status: [],

        //全城市管理员可以选择城市
        city_list: [],
        city_list_name: '',
        city_code: '',
        showList: false,
        all: '',

        // 行政编码
        area_code: '',

        checkList: [],
        checbBoxText: [],




        // 当前城市
        currentCity: '',

        // 城市列表拉出开关
        city_group_show: false,

        // 城市名称
        city_name_group: [],

        // city_code_group:[],


        priceList: [],
        priceListAll: [],

        // 表单数据
        submit_data: {
          driver_code: '',
          order_mode_code: '',
          start_name: '',
          start_coordinate: '',
          end_name: '',
          end_coordinate: '',
          consumer_name: '',
          consumer_phone: '',
          order_time: '',
          driver_number: '',
          remarks: ''
        },



        // 司机头像路径
        url: '',


        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          name: '',
          company_code: '',
          phone: '',
          telephone: '',
          boss: ''
        },
        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },




      }
    },
    watch: {
      firstlog() {
        if (_this.firstlog) {

          _this.onSocket();


        } else {

          // 关闭socket
          if (_this.global.ws) {
            _this.global.ws.close();
          }

        }
      }
    },
    methods: {

      cityChange(e) {

        // console.log(e)
        this.city_list_name = e.city.name

        console.log(this.city_list_name);


        var address = `${e.city.name}市政府`

        var geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
        });

        geocoder.getLocation(address, function (status, result) {


          _this.area_code = result.geocodes[0].adcode;

          // 平移地图
          map.panTo([result.geocodes[0].location.lng, result.geocodes[0].location.lat]);


          // 将城市赋值
          _this.currentCity = result.geocodes[0].addressComponent.city;

          // 设置地图层级
          map.setZoom(11)
        });

        this.city_code = e.city.city_code

        this.searchPeople()

      },


      cityClear() {

        this.city_code = ''

        this.searchPeople()

      },



      // 查询人数
      searchPeople() {

        _this.priceList = []


        _this.$post(
          "/statistics/getDriverStatusSubmit", {
            city_code: _this.city_code
          }
        ).then(res => {

          let obj = res.data;
          console.log(res)

          this.all = res.data.server_status_all
          let arr = Object.values(obj).forEach(element => {
            // console.log(element.num)
            _this.priceList.push(element.num)
          });

          _this.priceListAll = res.data;

          console.log(_this.priceListAll);

        }).catch((err) => {

        })
      },

      localSocket() {
        if ("WebSocket" in window) {
          console.log("您的浏览器支持 WebSocket!");

          _this.ws = new WebSocket(_this.$getSocketUrl());

          _this.global.setWs(_this.ws);

          _this.ws.onopen = _this.webSocketOnOpen;

          _this.ws.onerror = _this.webSocketOnError;


          _this.ws.onclose = _this.webSocketOnClose;


        } else {
          // 浏览器不支持 WebSocket
          console.log("您的浏览器不支持 WebSocket!");
        }
      },

      // 建立连接成功后的状态
      webSocketOnOpen() {


        // 发送数据
        // _this.global.ws.send(JSON.stringify(_this.sendData));


      },

      // 关闭连接
      webSocketOnClose() {

        console.log('socket已关闭');

        // console.log(_this.firstlog);

        if (_this.firstlog && _this.socket_relink_num < 10) {

          setTimeout(() => {

            _this.socket_relink_num += 1;
            _this.onSocket();

          }, 2000);



        } else if (_this.socket_relink_num >= 10) {

          _this.$notify({

            message: 'WebSocket链接失败,请刷新浏览器重试',
            duration: 0,
            type: 'warning',
            offset: 80

          });

        }


      },

      //连接失败的事件
      webSocketOnError(res) {


      },


      onSocket() {

        // var token = localStorage.getItem(config.localStorage_token_name);

        // // 哈希值
        // var hash_key = this.$hash_key();
        // _this.sendData.ws_mode = 'link';
        // _this.sendData.token = token;
        // _this.sendData.hash_key = hash_key;


        // 建立Socket连接
        _this.localSocket();



        // 长连接接收内容
        _this.global.ws.onmessage = function (res) {


          var resData = JSON.parse(res.data);

          _this.$driverState(resData);

          // console.log(resData);
          if (resData.identification == "link" && resData.header == "success") {
            console.log(resData);

            var data = {
              "server_status_0": 1,
              "server_status_1": 1,
              'server_status_2': 1,
              'server_status_3': 1,
              'server_status_4': 1,
              'server_status_5': 1,
              'server_status_6': 1,
              'switch': 1,
              'status': 88 // 1只返回听单中司机，2所有状态司机都返回
            }



            var sendData = {
              "ws_mode": 'driverControl',
              "driver_control_synchronization": JSON.stringify(data)
            }

            _this.global.ws.send(JSON.stringify(sendData));

            // console.log(JSON.stringify(sendData));


          } else if (resData.header == "error") {
            // 接收到弹窗信息

            _this.$message.error(resData.msg)



          } else if (resData.identification == "driver_control" && resData.header == "success") {
            // 如果接收到司机数据


            // 添加司机标签
            _this.addDriver(resData.data.driver_code, resData.data.real_name, resData.data.lng, resData.data.lat,
              resData.data.status, resData.data.server_status, resData.data.dan);


          } else if (resData.identification == "driver_offline" && resData.header == "success") {
            // 如果接收到司机下线数据

            if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {


              // 清除对应的司机标签
              _this.driver[resData.data.driver_code].setMap(null);

              // 将对象中对应的driver_code对象删除
              delete _this.driver[resData.data.driver_code];

            }

          } else if (resData.identification == "driver_control" && resData.header == "cut") {
            // 如果接收到司机cut数据

            if (typeof (_this.driver[resData.data.driver_code]) !== 'undefined') {

              // 清除对应的司机标签
              _this.driver[resData.data.driver_code].setMap(null);

              // 将对象中对应的driver_code对象删除
              delete _this.driver[resData.data.driver_code];

            }

          }

        };



      },


      // 添加司机方法
      addDriver(driver_code, name, lng, lat, status, server_status, dan) {


        // 如果存在筛选项
        // if (_this.checkList.length != 0) {

        // for (let i = 0; i < _this.checkList.length; i++) {

        // 如果接收到的数据status和筛选项一致
        // if (status == _this.checkList[i]) {


        // 根据司机状态决定文本标签的背景色
        switch (String(status)) {
          case '0':

            var backgroundColor = '#B9B9B9';

            break;
          case '1':

            var backgroundColor = '#61D59C';

            break;
          case '2':

            if (server_status == 1) {
              var backgroundColor = '#FA6705';
            } else if (server_status == 2) {
              var backgroundColor = '#BBC22C';
            } else if (server_status == 3) {
              var backgroundColor = '#FADC05';
            } else if (server_status == 4) {
              var backgroundColor = '#FAB105';
            } else if (server_status == 5) {
              var backgroundColor = '#9f3ecc';
            } else if (server_status == 6) {
              var backgroundColor = '#FA4705';
            }



            break;
          case '3':

            var backgroundColor = '#00A4DC';

            break;



          default:
            break;
        }




        // 如果driver_code存在,不需要新添加司机标签
        if (typeof (_this.driver[driver_code]) !== 'undefined') {


          // 如果接收到的数据不存在坐标并且司机标签已经存在，则只改变颜色
          if (lng != undefined && lng != null && lng != '' && lat != undefined && lat != null && lat != '') {

            //更改司机标签的坐标
            _this.driver[driver_code].setPosition([lng, lat]);

          }




          // 如果信息窗口存在并且已经打开
          if (_this.driverMarks_status[driver_code] && _this.driverMarks_status[driver_code].getIsOpen()) {


            // 更改司机信息窗口的坐标
            _this.driverMarks_status[driver_code].setPosition([lng, lat]);

          }



          _this.driver[driver_code].setStyle({

            'background-color': backgroundColor

          })




          return;
        } else if (typeof (_this.driver[driver_code]) == 'undefined' && (lng == undefined || lng == null || lng ==
            '' || lat == undefined || lat == null || lat == '')) {
          //如果driver_code不存在而且也没有坐标点直接直接return



          return;

        }




        // 根据司机状态决定文本标签的背景色
        switch (String(dan)) {
          case '0':

            var driver_logo = require('@/assets/11.png');

            break;
          case '1':

            var driver_logo = require('@/assets/22.png');

            break;
          case '2':

            var driver_logo = require('@/assets/33.png');



            break;
          case '3':

            var driver_logo = require('@/assets/44.png');



            break;

          default:
            break;
        }






        // 创建纯文本标记（司机标签）
        _this.driver[driver_code] = new AMap.Text({
          text: '<div style="display:flex;"><img style="margin:0 auto;display:block;width:25px;height:25px;" src="' +
            driver_logo + '">' + name + '</div>',
          anchor: 'center', // 设置文本标记锚点
          draggable: true,
          cursor: 'pointer',
          animation: 'AMAP_ANIMATION_DROP',
          angle: 0,
          style: {
            'padding': '.5rem .5rem',
            'margin-bottom': '1rem',
            'border-radius': '.25rem',
            'background-color': backgroundColor,
            'width': '',
            'border-width': 0,
            'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
            'text-align': 'center',
            'font-size': '14px',
            'color': '#fff'
          },
          position: [lng, lat]
        });

        _this.driver[driver_code].setMap(map);





        // 1秒后清除点标掉落效果的动画(防止点标抖动)
        setTimeout(() => {

          if (_this.driver[driver_code]) {
            _this.driver[driver_code].setAnimation('AMAP_ANIMATION_NONE')
          }

        }, 1000);


        // 文本标记的点击事件
        var clickHandle = AMap.event.addListener(_this.driver[driver_code], 'click', function () {


          _this.$post(
            "/driver/getPerformance", {
              driver_code: driver_code
            }
          ).then(res => {


            if (res.data.logo_img.url == '' || res.data.logo_img.url == null) {

              _this.url = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

            } else {

              _this.url = res.data.logo_img.url;

            }



            // 创建信息窗口
            _this.driverMarks_status[driver_code] = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: '<div style="width:180px;background-color:white;padding: 20px;box-sizing: border-box;border-radius: 5px">' +
                '<div style="overflow: hidden; width:80px;height:80px;margin:0 auto;border-radius: 50%;">' +
                '<img style="margin:0 auto;display:block;width:100%;height:100%;" src="' + _this.url +
                '">' +
                '</div>' +
                '<h4 style="text-align: center;font-weight: bold;font-size: 18px">' + name + '</h4>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">今日完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.today_order_nums + '单</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">本月完成</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.month_order_nums + '单</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">任职状态</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.capacity + '</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">综合指数</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.exponent_driver_points_ + '分</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">司机电话</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.phone + '</span> </p>' +
                '<p style="display: flex;margin: 10px 0;font-size: 12px;"><span style="display: inline-block;width: 50%;text-align: left;">定位时间</span> <span style="display: inline-block;width: 50%;text-align: left;">' +
                res.data.position_time.YmdHis + '</span> </p>' +
                '</div>',
              offset: new AMap.Pixel(0, -20)
            });

            //打开信息窗口
            _this.driverMarks_status[driver_code].open(map, _this.driver[driver_code]
              .getPosition()); //后面的参数指的是经纬度，在此显示窗口



          }).catch((err) => {

          })


        });


        // } else if (_this.checkList.indexOf(Number(status)) == -1) {
        //   //如果司机对应的状态未被勾选


        //   // 如果司机已经存在标签，则删除
        //   if (typeof (_this.driver[driver_code]) !== 'undefined') {

        //     // 清除对应的司机标签
        //     _this.driver[driver_code].setMap(null);

        //     // 将对象中对应的driver_code对象删除
        //     delete _this.driver[driver_code];

        //   }


        // }
        // }
        // }





      },


      // 管理司机信息窗口方法
      closePop() {
        // 遍历关闭信息窗口
        for (const key in _this.driverMarks_status) {
          _this.driverMarks_status[key].close();
        }

      },


      // 状态搜索多选框
      checkboxChenge(e, val) {



        // 如果取消筛选
        if (e == false) {

          for (const key in _this.driver) {

            // 清除所有司机标签
            _this.driver[key].setMap(null);

            // 清空driver对象
            delete _this.driver[key];

          }

        }

      },



    }
  }
</script>
<style scoped>
  @import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';


  #container {
    width: 100%;
    height: 100vh;
  }

  .checkboxGroup {
    position: absolute;
    top: 25px;
    left: 30px;
    padding: 10px 20px;
    z-index: 1;
    background-color: #fff;
    border-radius: 20px;
    /* min-width: 1000px; */
    width: 200px;
    /* padding: 20px 0; */
  }

  .city-box {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999999999;
  }

  .pull {
    display: flex;
    padding: 20px 5px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-100%, -50%);
    transition: all 0.1s linear;
    justify-content: center;
  }

  .city-group {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    max-width: 300px;
    max-height: 500px;
    box-shadow: 1px 1px 5px #ccc;
    background-color: #fff;
    cursor: pointer;
    overflow-y: auto;
  }

  .city-group .city-name {
    padding-left: 20px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .city-group .city-name:hover {
    background-color: #ccc;
    transition: .2s;
  }



  .active {
    background-color: #ccc;
  }
</style>
<style>
  .checkboxGroup>.div-color {
    font-weight: 800;
    padding: 10px 0;
  }

  .checkboxGroup>.div-color:nth-of-type(2) {
    color: #B9B9B9 !important;

  }

  .checkboxGroup>.div-color:nth-of-type(3) {
    color: #61D59C !important;
  }

  .checkboxGroup>.div-color:nth-of-type(4) {
    color: #00A4DC !important;
  }

  .checkboxGroup>.div-color:nth-of-type(5) {
    color: #FA6705 !important;
  }

  .checkboxGroup>.div-color:nth-of-type(6) {
    color: #BBC22C !important;
  }

  .checkboxGroup>.div-color:nth-of-type(7) {
    color: #FADC05 !important;
  }

  .checkboxGroup>.div-color:nth-of-type(8) {
    color: #FAB105 !important;
  }

  .checkboxGroup>.div-color:nth-of-type(9) {
    color: #9f3ecc !important;
  }

  .checkboxGroup>.div-color:nth-of-type(10) {
    color: #FA4705 !important;
  }
</style>
